// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"722659f8","728":"9a1f3e78"}[chunkId] + ".chunk.css";
};